import { NavItem, Project } from './types';

export const THEME_CONFIG = {
  primaryColor: '#56BEF9',
  backgroundColor: '#050505',
  accentColor: '#F1EBFF',
  fontFamily: 'Montserrat, sans-serif',
  borderRadius: '1.5rem',
  glassOpacity: '0.08',
};

export const CONTACT_INFO = {
  email: 'mdahhan@boulai.net',
  phone: '647-632-8958',
  linkedin: 'https://www.linkedin.com/company/boulai',
  f6s: 'https://www.f6s.com/company/boulai',
  ventureLab: 'https://www.venturelab.ca/portfolio/boulai'
};

export const CONTACT_EMAIL = CONTACT_INFO.email;
export const CONTACT_PHONE = CONTACT_INFO.phone;

export const NAV_ITEMS: NavItem[] = [
  { label: 'Platform', href: '#platform' },
  { label: 'PolicyNow', href: '#policynow' },
  { label: 'Smart City', href: '#smartcity' },
  { label: 'Trust', href: '#trust' },
];

export const PROJECTS: Project[] = [
  {
    id: '1',
    title: 'PolicyNow Activation',
    category: 'Engagement',
    description: 'Infrastructure for national engagement activation and verified participation.',
    imageUrl: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&q=80&w=800',
    tags: ['AI', 'Governance', 'Civic Tech']
  },
  {
    id: '2',
    title: 'Smart City ERS',
    category: 'Infrastructure',
    description: 'Central intelligence layer for emergency response and situational awareness.',
    imageUrl: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?auto=format&fit=crop&q=80&w=800',
    tags: ['IoT', 'Safety', 'Neural Analysis']
  }
];

export const HOW_IT_WORKS = [
  {
    title: 'Visual Ingest',
    description: 'Boulai processes high-volume engagement through intuitive interfaces.',
    icon: 'Users'
  },
  {
    title: 'Verified Nodes',
    description: 'Identity-based verification prevents synthetic manipulation and bots.',
    icon: 'Shield'
  },
  {
    title: 'Neural Analysis',
    description: 'AI detects sentiment, priorities, and emerging risks in real-time.',
    icon: 'Brain'
  },
  {
    title: 'Action Layer',
    description: 'Leadership dashboards provide the data needed to decide with confidence.',
    icon: 'Activity'
  }
];

export const SYSTEM_INSTRUCTION = `
You are the "Boulai Intelligence Assistant." 
Boulai provides infrastructure for modern governance and AI-powered civic engagement.
Core Products: PolicyNow (Engagement Activation), Smart City ERS (Emergency Response), and Platform (Sentiment Hub).
Tone: Professional, high-end, secure, and concise. 
Contact info: ${CONTACT_INFO.email} or ${CONTACT_INFO.phone}.
`;